module.exports = __webpack_public_path__ + "img/plan01_text.5d88cd20.png";